<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{ (idReuniao ? 'Editar' : 'Adicionar') | translate }} {{'Reunião' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <ion-grid>
      <ng-container>
        <ion-item lines="none">
          <ion-input
            labelPlacement="floating"
            type="text"
            formControlName="responsavel"
          ><div slot="label">{{'Responsável' | translate}} <ion-text color="danger">*</ion-text></div></ion-input>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.responsavel">
            <div
              class="error-message"
              *ngIf="validations_form.get('responsavel')?.hasError(validation.type) && (validations_form.get('responsavel')?.dirty || validations_form.get('responsavel')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ion-item-divider></ion-item-divider>

      <ng-container>
        <ion-item lines="none">
          <ion-input
            labelPlacement="floating"
            type="text"
            formControlName="tema"
          ><div slot="label">{{'Tema' | translate}} <ion-text color="danger">*</ion-text></div></ion-input>
        </ion-item>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.tema">
            <div
              class="error-message"
              *ngIf="validations_form.get('tema')?.hasError(validation.type) && (validations_form.get('tema')?.dirty || validations_form.get('tema')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ion-item-divider></ion-item-divider>

      <ng-container>
        <prover-datepicker
          [labelName]="'Data'"
          [id]="'data'"
          formControlName="data"
          [required]="true"
        ></prover-datepicker>

        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.data">
            <div
              class="error-message"
              *ngIf="validations_form.get('data')?.hasError(validation.type) && (validations_form.get('data')?.dirty || validations_form.get('dataHoraFim_data')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ion-item-divider></ion-item-divider>

      <app-prover-horas
        [labelName]="'Hora Início'"
        [id]="'horaInicio'"
        formControlName="horaInicio"
        [required]="true"
        [isLabel]="true"
      ></app-prover-horas>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.horaInicio">
          <div
            class="error-message"
            *ngIf="validations_form.get('horaInicio')?.hasError(validation.type) && (validations_form.get('horaInicio')?.dirty || validations_form.get('horaInicio')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <ion-item-divider></ion-item-divider>

      <app-prover-horas
        [labelName]="'Hora Fim'"
        [id]="'horaFim'"
        formControlName="horaFim"
        [required]="true"
        [isLabel]="true"
      ></app-prover-horas>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.horaFim">
          <div
            class="error-message"
            *ngIf="validations_form.get('horaFim')?.hasError(validation.type) && (validations_form.get('horaFim')?.dirty || validations_form.get('horaFim')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <ion-item-divider></ion-item-divider>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item>
            <ion-select
              labelPlacement="stacked"
              interface="action-sheet"
              label="{{'Tipo de reunião' | translate}}"
              placeholder="{{'Tipo de reunião' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idProjetoTipo"
            >
              <ion-select-option [value]="7">{{'-- Selecione --' | translate}}</ion-select-option>
              <ion-select-option *ngFor="let tipo of tipos" [value]="tipo.id">{{tipo.nome}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-item-divider></ion-item-divider>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-textarea
              label="{{'Observação' | translate}}"
              labelPlacement="floating"
              rows="3"
              [disabled]="readOnly"
              formControlName="observacao"
            ></ion-textarea>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-item-divider></ion-item-divider>

      <ion-row class="ion-justify-content-center">
        <ion-col size="7">
          <div>
            <ion-button
              class="btn-success"
              expand="block"
              type="submit"
              *ngIf="!readOnly"
              [disabled]="!validations_form.valid"
            >
              {{'Salvar' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
